module.exports = function dynamicContentProduct(template, itemType) {
    return function () {
        return {
            restrict: 'E',
            require: '^olyDynamicContent',
            scope: {
                itemId: '@',
                forceSmallFormatView: '=?',
            },
            link(scope, element, attrs, dcCtrl) {
                dcCtrl.getServerItem(parseInt(scope.itemId), itemType)
                    .then((item) => {
                        scope.item = item;
                    });
            },
            template,
        };
    };
};



// WEBPACK FOOTER //
// ./src/common/dynamiccontent/dynamic-content-item.directive.js